import React from 'react';
import { Checkbox, withStyles } from '@material-ui/core';

const GreyCheckBox = withStyles({
  root: {
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0
    },
    "& .MuiIconButton-label:after": {
      content: '""',
      height: '1rem',
      width: '1rem',
      position: "absolute",
      backgroundColor: "#CFD8E0",
      zIndex: -1
    },

    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        height: '1rem',
        width: '1rem',
        position: "absolute",
        backgroundColor: "rgb(12, 77, 130)",
        zIndex: -1
      }
    }
  },
  checked: {
    color: '#CFD8E0',
  }
})((props) => <Checkbox color="default" {...props} />);

export default GreyCheckBox
